import { Component, type ReactNode } from 'react'

import { type Tenant } from 'types/shopConfig'

class Variant extends Component<ComponentProps> {
  render() {
    const { children, variables = {} } = this.props

    return children(variables)
  }
}

type ComponentProps = {
  name: string
  children: (args: unknown) => ReactNode
  variables?: Record<string, unknown> | Record<string, never>
  // tenant prop is checked in the parent `Experiment` component
  tenant?: Tenant | Tenant[] | null
}

export default Variant
